<template>
  <div id="app">
      <keep-alive :include="keepList">
          <router-view />
      </keep-alive>
  </div>
</template>

<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
    name: "App",
    data() {
        return {
            keepList: ['MenuMobile']
        };
    },
    // 方法集合
    methods: {
        // 获取设备ID
        getDeviceId () {
            FingerprintJS.load().then(fp => {
                fp.get().then(res => {
                    const visitorId = res.visitorId;
                    localStorage.setItem('deviceId', visitorId)
                });
            })
        }
    },
    // 创建完成
    created() {
        // 获取设备ID
        this.getDeviceId()
    }
};
</script>

<style lang="scss">

</style>
